<!-- ==============================
  File Name: ClientList.vue
  Description: Client List page
=============================== -->

<template>
  <div id="page-client-list">
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20'
          icon="UsersIcon"
          statistic="Clients"
          :statisticTitle="totalClientCount"
          statisticSubTitle="Total"
          :chartData="subscribersGained.series"
          type="area"
        ></statistics-card-line>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20'
          icon="ShoppingBagIcon"
          statistic="Clients"
          :statisticTitle="totalActiveClientCount"
          statisticSubTitle="Active"
          color="warning"
          :chartData="subscribersGained.series"
          type="area"
        ></statistics-card-line>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20'
          icon="UsersIcon"
          statistic="New"
          :statisticTitle="totalNewClientCount"
          statisticSubTitle="Past 30 days"
          :chartData="subscribersGained.series"
          type="area"
        ></statistics-card-line>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line class='font-20'
          icon="ShoppingBagIcon"
          statistic="Lost"
          :statisticTitle="totalLostClientCount"
          statisticSubTitle="Past 30 days"
          :chartData="subscribersGained.series"
          color="warning"
          type="area"
        ></statistics-card-line>
      </div>
    </div>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <!-- <span
                class="mr-2"
              >{{ totalRecordCount === 0 ? 0 : currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ this.totalRecordCount - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : totalRecordCount}} of {{ this.totalRecordCount }}</span> -->
              <span class="mr-2">
                {{ (this.totalRecordCount > 0)? (currentPage * paginationPageSize - (paginationPageSize - 1)) : 0 }} - {{ this.totalRecordCount - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : totalRecordCount}} of {{ this.totalRecordCount }}
              </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <vs-button @click.prevent="redirectToAddClient" v-if="userIsManagerOrAdmin">Add Client</vs-button>
      </div>
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 h-610 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="clientsData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage"/>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "../../../ui-elements/card/analyticsData.js";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import VxTimeline from "@/components/timeline/VxTimeline";
import * as moment from 'moment-timezone';

// Store Module
import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";

// Cell Renderer
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererDuration from "./cell-renderer/CellRendererDuration.vue";
import UtilService from "@/services/UtilService";
import ClientService from "@/services/ClientService";
import PartnerService from "@/services/PartnerService";

export default {
  components: {
    AgGridVue,
    vSelect,
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline,
    CellRendererStatus,
    CellRendererActions,
    CellRendererDuration,
  },
  data() {
    return {
      userInfo: {},
      userZone: "",
      subscribersGained: {},
      client: [],
      total: 0,
      totalClientCount: 0,
      totalActiveClientCount: 0,
      totalLostClientCount : 0,
      totalNewClientCount : 0,
      totalRecordCount: 0,
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ],
      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" }
      ],
      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],
      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" }
      ],
      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {
         onFilterChanged: (event) => { 
          this.totalRecordCount = (this.client && this.client.length === event.api.paginationGetRowCount())? this.client.length : event.api.paginationGetRowCount()
        },
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: "Created Date",
          field: "CreatedDate",
          width: 160,
          filter: true,
          sortable: true,
          sort: ['desc'],
          cellRenderer: (data) => {
            
            // return data.value;

            var date = data.value.slice(0,-3);

            const tzid = Intl.DateTimeFormat().resolvedOptions().timeZone;

            var created_at = moment(date).tz(tzid).format('YYYY-MM-DD HH:mm:ss');
            // console.log(created_at);
            return created_at;
          }
        },
        {
          headerName: "Company",
          field: "CompanyName",
          width: 225,
          filter: true,
          sortable: true
        },
        {
          headerName: "Partner",
          field: "Partner",
          filter: true,
          width: 210,
          sortable: true
        },
        {
          headerName: "Type",
          field: "ClientType",
          filter: true,
          width: 225,
          sortable: true
        },
        {
          headerName: "Commission",
          field: "Commission",
          filter: true,
          width: 120,
          sortable: true
        },
        {
          headerName: "Industry",
          field: "Industry",
          filter: true,
          width: 150,
          sortable: true
        },
        {
          headerName: "Reference",
          field: "Reference",
          filter: true,
          width: 150,
          sortable: true
        },
        {
          headerName: "City",
          field: "City",
          filter: true,
          width: 150,
          sortable: true
        },
        {
          headerName: "Start",
          field: "StartDate",
          filter: true,
          width: 180,
          sortable: true
        },
        {
          headerName: "End",
          field: "EndDate",
          filter: true,
          width: 180,
          sortable: true
        },
        {
          headerName: "Duration",
          field: "Duration",
          filter: true,
          width: 120,
          cellRendererFramework: "CellRendererDuration",
          sortable: true
        },
        {
          headerName: "Status",
          field: "Status",
          filter: true,
          width: 100,
          cellRendererFramework: "CellRendererStatus",
          sortable: true
        },
        {
          headerName: "Actions",
          field: "transactions",
          width: 150,
          cellRendererFramework: "CellRendererActions"
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererStatus,
        CellRendererActions,
        CellRendererDuration,
      }
    };
  },
  watch: {
    roleFilter(obj) {
      this.setColumnFilter("role", obj.value);
    },
    statusFilter(obj) {
      this.setColumnFilter("status", obj.value);
    },
    isVerifiedFilter(obj) {
      const val =
        obj.value === "all" ? "all" : obj.value === "yes" ? "true" : "false";
      this.setColumnFilter("is_verified", val);
    },
    departmentFilter(obj) {
      this.setColumnFilter("department", obj.value);
    }
  },
  computed: {
    userIsManagerOrAdmin () {
      return this.userInfo && (this.userInfo.Role === 'Admin' || this.userInfo.Role === 'Manager')
    },
    clientsData() {
      return this.client;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;
      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }
      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = {
        label: "All",
        value: "all"
      };
      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    redirectToAddClient() {
      this.$router.push("/apps/client/add");
    },
    getClients() {
      if (this.userInfo) {
        let lastRecordKey = ''
        ClientService.getLastRecordKey().on("value", function(snapshot) {
          snapshot.forEach(function(data) {
            lastRecordKey = data.key;
          });
        });
        ClientService.getAll(this.userInfo).on("value", items => {
          this.client = [];
          let Clients = [];
          let index1 = 0;
          this.totalActiveClientCount = 0;
          this.totalClientCount = 0;
          this.totalNewClientCount = 0;
          this.totalLostClientCount = 0;
          let pastDate = new Date(new Date().setDate(new Date().getDate() - 30));
          items.forEach((item, index) => {
            let key = item.key;
            let clientData = item.val();
            if(clientData['IsDeleted'] == 0){
              clientData['StartDate'] = UtilService.convertUTCToCurrentZone(clientData['StartDate'],this.userZone)
              clientData['EndDate'] = UtilService.convertUTCToCurrentZone(clientData['EndDate'],this.userZone)
              this.totalClientCount += 1;
              if (clientData["Status"] == "Active" || clientData["IsActive"] == 1) {
                this.totalActiveClientCount += 1;
              }
              if((new Date(clientData['StartDate']) <= new Date()) && (new Date(clientData['StartDate'])>= pastDate))
              {
                this.totalNewClientCount += 1;
              }
              if((new Date(clientData['EndDate']) <= new Date()) && (new Date(clientData['EndDate'])>= pastDate))
              {
                this.totalLostClientCount += 1;
              }
              PartnerService.getPartnerById(clientData['Partner']).on ( "value", items => {
                items.forEach(item => {
                  let partner = item.val();
                  clientData['Partner'] = partner['CompanyName'];
                })
                Clients.push({ ...clientData });          
              })
            }
            if(key == lastRecordKey){
              
              this.client = Clients.sort(function(a, b) {
                return new Date(a.ModifiedDate) - new Date(b.ModifiedDate);
              });
            }
          });
          
        });
      }
    }
  
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    /* ======
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ====== */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  updated(){
    this.totalRecordCount = this.client.length;
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    this.userZone = this.userInfo.Timezone;
    if(this.userInfo.Role == 'Partner Admin' || this.userInfo.Role == 'Partner Staff'){
      this.columnDefs.splice(1,1);
    }
    this.getClients();
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
.h-610 {
  height: 610px;
}
.font-20{
  font-size: 20px;
}
</style>
